// extracted by mini-css-extract-plugin
export default {"default-warranty":"rules_default-warranty__LolzW","ant-input":"rules_ant-input__fz42f","ant-btn":"rules_ant-btn__-CojA"};